import React, {Component} from 'react';
import './../../../../style/roomAndBed.css'
import {BiBed} from 'react-icons/bi';
import {TbBuilding} from 'react-icons/tb';
import {MdDateRange} from 'react-icons/md';
import {AiOutlineNumber} from 'react-icons/ai';
import {AiOutlineUser} from 'react-icons/ai';
import {IoMdMore} from "react-icons/io";
import {BsPersonCircle} from "react-icons/bs";
import {Link} from "react-router-dom";
import BuildingContext from '../../../../contexts/Building';
import FloorAndBedLoading from '../../../loading/FloorAndBedLoading';
import {Button, Modal} from 'react-bootstrap';
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";
import axios from "axios";
import {FiEdit2} from "react-icons/fi";
import { API_BASE_URL } from '../../../../api/client';
import  {BsFillDoorOpenFill} from  "react-icons/bs"

class Bed extends Component {
    static contextType = BuildingContext;
    searchTimer = null;
    searchRequestId = 0;
    personLoadId = 0;

    emptyTempPerson = () => ({
        id: '',
        firstName: '',
        lastName: '',
        nationalCode: '',
        birthDate: '',
        fatherName: '',
        timePeriod: {
            startDate: "",
            endDate: ""
        },
        image: 'https://www.business2community.com/wp-content/uploads/2017/08/blank-profile-picture-973460_640.png'
    });

    state = {
        isLoading: false,
        beds: [],
        room:{},
        isFull: false,
        show: false,
        selectedPeople: "",
        personLoading: false,
        bedOpen:
            {
                id: '', name: '', empty: false,
                personId: "",
            },

        tempPerson: {
            id: '',
            firstName: '',
            lastName: '',
            nationalCode: '',
            birthDate: '',
            timePeriod: {
                startDate: "",
                endDate: ""
            },
            image: 'https://www.business2community.com/wp-content/uploads/2017/08/blank-profile-picture-973460_640.png'
        },

        searchInput: "",
        searchType: "fullName",
        peopleFound: [],
    }

    componentWillUnmount() {
        if (this.searchTimer) clearTimeout(this.searchTimer);
        this.searchRequestId += 1;
    }

    sortBeds = (beds) => [...(beds || [])].sort((a, b) =>
        String(a?.name ?? '').localeCompare(String(b?.name ?? ''), 'fa', {numeric: true})
    );

    enrichBedOccupants = async (beds) => {
        const headers = {'Authorization': localStorage.getItem('accessToken')};
        const sorted = this.sortBeds(beds);
        return Promise.all(sorted.map(async (bed) => {
            if (bed.empty || !bed.person) {
                return {...bed, occupantFullName: ''};
            }
            try {
                const person = await axios.get(`${API_BASE_URL}/api/v1/supervisor/person/${bed.person}`, {headers}).then(r => r.data);
                const characteristic = await axios.get(`${API_BASE_URL}/api/v1/supervisor/characteristic/${person.characteristicId}`, {headers}).then(r => r.data);
                const occupantFullName = characteristic.fullName
                    || `${characteristic.firstName || ''} ${characteristic.lastName || ''}`.trim();
                return {...bed, occupantFullName};
            } catch (e) {
                return {...bed, occupantFullName: ''};
            }
        }));
    };

    applyBedsState = async (data) => {
        const beds = await this.enrichBedOccupants(data);
        this.setState({beds, isLoading: false}, () => {
            if (beds.length === 0) {
                this.setState({isFull: false});
            } else {
                this.setState({isFull: true});
            }
        });
    };

    async componentDidMount() {
        const roomId = window.location.href.slice(-32)
        axios.get(`${API_BASE_URL}/api/v1/supervisor/room/getBeds/${roomId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then((data) => this.applyBedsState(data)).catch(() => {
            if (localStorage.getItem('role') === 'MANAGER') {
                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/room/getBeds/${roomId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then((data) => this.applyBedsState(data))
                        } else {
                            window.location = '/'
                        }
                    })
            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/room/getBeds/${roomId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then((data) => this.applyBedsState(data))
                        } else {
                            window.location = '/'
                        }
                    })
            }
        })

        axios.get(`${API_BASE_URL}/api/v1/supervisor/room/${roomId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then((data) => this.setState({room: data, isLoading: false}, () => {
                if (data.length === 0) {
                    this.setState({isFull: false})
                } else {
                    this.setState({isFull: true})
                }
            })).catch(() => {
            if (localStorage.getItem('role') === 'MANAGER') {
                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/room/${roomId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then((data) => this.setState({room: data, isLoading: false}, () => {
                                    if (data.length === 0) {
                                        this.setState({isFull: false})
                                    } else {
                                        this.setState({isFull: true})
                                    }
                                }))
                        } else {
                            window.location = '/'
                        }
                    })
            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.get(`${API_BASE_URL}/api/v1/supervisor/room/${roomId}`, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then((data) => this.setState({room: data, isLoading: false}, () => {
                                    if (data.length === 0) {
                                        this.setState({isFull: false})
                                    } else {
                                        this.setState({isFull: true})
                                    }
                                }))
                        } else {
                            window.location = '/'
                        }
                    })
            }
        })

    }

    handleClose = () => {
        this.personLoadId += 1;
        this.setState({
            show: false,
            tempPerson: this.emptyTempPerson(),
            personLoading: false,
            peopleFound: [],
            selectedPeople: '',
            searchInput: '',
        });
    };

    handleSubmit = async () => {
        if (!this.state.selectedPeople) {
            return;
        }
        const markOccupied = () => {
            let updateState = [...this.state.beds];
            let bedIndex = updateState.findIndex((bed) => bed.id === this.state.bedOpen.id);
            if (bedIndex < 0) {
                return;
            }
            updateState[bedIndex].empty = false;
            updateState[bedIndex].person = this.state.selectedPeople;
            this.setState({beds: updateState});
        };
        axios.put(`${API_BASE_URL}/api/v1/supervisor/bed/${this.state.bedOpen.id}`, {
            personId: this.state.selectedPeople,
            empty: false
        }, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then(() => {
                markOccupied();
                this.handleClose();
            }).catch((error) => {
            if (error?.response?.status === 409) {
                const data = error.response.data;
                let msg = data?.message || data?.error
                    || (typeof data === 'string' ? data : null)
                    || 'تخت پر است';
                const quoted = typeof msg === 'string' && msg.match(/"([^"]+)"/);
                if (quoted) msg = quoted[1];
                alert(msg);
                return;
            }
            if (localStorage.getItem('role') === 'MANAGER') {
                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.put(`${API_BASE_URL}/api/v1/supervisor/bed/${this.state.bedOpen.id}`, {
                                personId: this.state.selectedPeople,
                                empty: false
                            },{headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then(() => {
                                    markOccupied();
                                    this.handleClose();
                                }).catch((retryError) => {
                                if (retryError?.response?.status === 409) {
                                    alert(retryError.response.data?.message || 'تخت پر است');
                                } else {
                                    console.log(retryError)
                                }
                            })
                        } else {
                            window.location = '/'
                        }
                    })
            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.put(`${API_BASE_URL}/api/v1/supervisor/bed/${this.state.bedOpen.id}`, {
                                personId: this.state.selectedPeople,
                                empty: false
                            }, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then(() => {
                                    markOccupied();
                                    this.handleClose();
                                }).catch((retryError) => {
                                if (retryError?.response?.status === 409) {
                                    alert(retryError.response.data?.message || 'تخت پر است');
                                } else {
                                    console.log(retryError)
                                }
                            })
                        } else {
                            window.location = '/'
                        }
                    })
            }
        })
    }

    authHeaders = () => ({'Authorization': localStorage.getItem('accessToken')});

    refreshAndRetry = async (requestFn) => {
        const role = localStorage.getItem('role');
        const refreshUrl = role === 'MANAGER'
            ? `${API_BASE_URL}/api/v1/manager/token/refresh`
            : role === 'SUPERVISOR'
                ? `${API_BASE_URL}/api/v1/supervisor/token/refresh`
                : null;
        if (!refreshUrl) throw new Error('no refresh');
        const response = await axios.get(refreshUrl, {
            headers: {'Authorization': localStorage.getItem('refreshToken')}
        });
        if (!response.headers["accesstoken"]) {
            window.location = '/';
            throw new Error('session expired');
        }
        localStorage.setItem("accessToken", response.headers["accesstoken"]);
        return requestFn();
    }

    handleShow = async (bed) => {
        const loadId = ++this.personLoadId;
        const isEmpty = bed.empty === true || bed.empty === 'true' || !bed.person;

        this.setState({
            bedOpen: bed,
            show: true,
            tempPerson: this.emptyTempPerson(),
            peopleFound: [],
            selectedPeople: '',
            searchInput: '',
            personLoading: !isEmpty,
        });

        if (isEmpty) {
            return;
        }

        const personId = bed.person;
        try {
            const getPerson = () => axios.get(
                `${API_BASE_URL}/api/v1/supervisor/person/${personId}`,
                {headers: this.authHeaders()}
            ).then(r => r.data);

            let person;
            try {
                person = await getPerson();
            } catch (e) {
                person = await this.refreshAndRetry(getPerson);
            }
            if (loadId !== this.personLoadId) return;

            if (!person?.characteristicId) {
                this.setState({personLoading: false});
                return;
            }

            const getChar = () => axios.get(
                `${API_BASE_URL}/api/v1/supervisor/characteristic/${person.characteristicId}`,
                {headers: this.authHeaders()}
            ).then(r => r.data);

            let characteristic;
            try {
                characteristic = await getChar();
            } catch (e) {
                characteristic = await this.refreshAndRetry(getChar);
            }
            if (loadId !== this.personLoadId) return;

            this.setState({
                tempPerson: {
                    ...this.emptyTempPerson(),
                    ...characteristic,
                    timePeriod: characteristic?.timePeriod || {startDate: '', endDate: ''},
                },
                personLoading: false,
            });
        } catch (e) {
            if (loadId === this.personLoadId) {
                this.setState({personLoading: false});
            }
        }
    };

    handleCloseAccessory = () => {
        this.setState({showAccessory: false})
    };

    handleShowAccessory = () => {
        this.setState({showAccessory: true})
    };
    handleCloseRoomAcc = () => {
        this.setState({showRoomAccessory: false})
    }
    handleShowRoomAcc = (room) => {
        this.setState({showRoomAccessory: true})
        this.setState({tempRoom: room})
    }
    handleChange = (event, newAlignment) => {
        console.log(newAlignment)
        this.setState({selectedPeople: newAlignment})
    }

    //search
    handleSearchInput = (e) => {
        const value = e.target.value;
        this.setState({searchInput: value});
        if (this.searchTimer) clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => this.runPeopleSearch(value), 350);
    }

    runPeopleSearch = (rawValue) => {
        const value = (rawValue || '').trim();
        const requestId = ++this.searchRequestId;
        if (!value) {
            this.setState({peopleFound: []});
            return;
        }
        const url = `${API_BASE_URL}/api/v1/supervisor/characteristic/search?parentType=Person&${this.state.searchType}=${encodeURIComponent(value)}`;
        const apply = (data) => {
            if (requestId !== this.searchRequestId) return;
            this.setState({peopleFound: Array.isArray(data) ? data : []});
        };

        axios.get(url, {headers: {'Authorization': localStorage.getItem('accessToken')}})
            .then(response => response.data)
            .then(apply)
            .catch(() => {
                if (localStorage.getItem('role') === 'MANAGER') {
                    axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then((response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                axios.get(url, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                    .then(r => r.data).then(apply);
                            } else {
                                window.location = '/'
                            }
                        })
                } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                    axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                        .then((response) => {
                            if (response.headers["accesstoken"]) {
                                localStorage.setItem("accessToken", response.headers["accesstoken"]);
                                axios.get(url, {headers: {'Authorization': localStorage.getItem('accessToken')}})
                                    .then(r => r.data).then(apply);
                            } else {
                                window.location = '/'
                            }
                        })
                }
            })
    }
    //delete Person
    handleDeletePerson = () =>{
        const bedId = this.state.bedOpen?.id;
        if (!bedId) {
            return;
        }
        if (!window.confirm('اتمام اقامت برای این تخت انجام شود؟')) {
            return;
        }
        const markEmpty = () => {
            let updateState = [...this.state.beds];
            let bedIndex = updateState.findIndex((bed) => bed.id === bedId);
            if (bedIndex < 0) {
                return;
            }
            updateState[bedIndex].empty = true;
            updateState[bedIndex].person = null;
            this.setState({beds: updateState});
        };
        const payload = {empty: true};
        axios.put(`${API_BASE_URL}/api/v1/supervisor/bed/${bedId}`, payload, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
            .then(() => {
                markEmpty();
                this.handleClose();
            }).catch(() => {
            if (localStorage.getItem('role') === 'MANAGER') {
                axios.get(`${API_BASE_URL}/api/v1/manager/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.put(`${API_BASE_URL}/api/v1/supervisor/bed/${bedId}`, payload,{headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then(() => {
                                    markEmpty();
                                    this.handleClose();
                                }).catch((error) => {
                                alert('اتمام اقامت ناموفق بود');
                                console.log(error)
                            })
                        } else {
                            window.location = '/'
                        }
                    })
            } else if (localStorage.getItem('role') === 'SUPERVISOR') {
                axios.get(`${API_BASE_URL}/api/v1/supervisor/token/refresh`, {headers: {'Authorization': localStorage.getItem('refreshToken')}})
                    .then((response) => {
                        if (response.headers["accesstoken"]) {
                            localStorage.setItem("accessToken", response.headers["accesstoken"]);
                            axios.put(`${API_BASE_URL}/api/v1/supervisor/bed/${bedId}`, payload, {headers: {'Authorization': localStorage.getItem('accessToken')}}).then(response => response.data)
                                .then(() => {
                                    markEmpty();
                                    this.handleClose();
                                }).catch((error) => {
                                alert('اتمام اقامت ناموفق بود');
                                console.log(error)
                            })
                        } else {
                            window.location = '/'
                        }
                    })
            } else {
                alert('اتمام اقامت ناموفق بود');
            }
        })
    }
    render() {
        return (
            <>
                <div className='unitContainer'>
                    <div className="page-title-row">
                        <div className="text">
                            <h4>انتخاب تخت</h4>
                            <p>
                                تخت را انتخاب کنید و شخص مورد نظر خود را به آن بیافزاید
                            </p>
                        </div>
                        <div className="page-actions">
                            <Link className="back-btn" to={`/dashboard/booking/floor/unit/${this.state.room.unit || ''}`}>
                                بازگشت
                                <i className="bi bi-caret-left-fill"/>
                            </Link>
                        </div>
                    </div>
                    <h2 className='unit-name'>
                        <BsFillDoorOpenFill className="mt-2" color='#555' fontSize="1.8rem"/>
                        <span className="unit-title">اتاق {this.state.room.number}</span>
                    </h2>
                    <div className={`d-flex justify-content-end ${this.state.isFull ? "edit-btn-container" : "register-btn-container"}`}>
                        <Link to={`/dashboard/booking/edit-bed/${this.state.room.id}`}
                              className={this.state.isFull ? "edit-btn" : "btn btn-success"}>
                            {this.state.isFull ? (<h6><FiEdit2 className='ms-1' />ویرایش</h6>) : (<h6> ثبت تخت</h6>)}
                        </Link>
                    </div>

                    {
                        this.state.isLoading ? (
                            <div className='row' style={{marginTop: "60px"}}>
                                <FloorAndBedLoading/>
                            </div>
                        ) : (
                            <div>
                                <div className="mt-4 d-flex flex-wrap row justify-content-center">
                                    {
                                        this.state.beds.map(
                                            (bed) => (
                                                <div className="col-md-3 col-sm-4 col-xs-12">
                                                    <div className={`bed-box ${bed.empty ? "empty" : "full"}`}>
                                                        <Button onClick={() => {
                                                            this.handleShow(bed)
                                                        }}>
                                                            <BiBed fontSize="2rem"/>
                                                            <div className="title">{bed.name}</div>
                                                            {bed.occupantFullName ? (
                                                                <div className="text-muted small mt-1">{bed.occupantFullName}</div>
                                                            ) : null}
                                                        </Button>
                                                    </div>
                                                </div>
                                            )
                                        )
                                    }
                                </div>
                            </div>
                        )
                    }
                </div>
                <Modal size="lg" centered show={this.state.show} onHide={() => {
                    this.handleClose()
                }}>
                    <Modal.Header closeButton>
                        <Modal.Title>اتاق {this.state.bedOpen.name}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            (!this.state.bedOpen.empty && this.state.bedOpen.person) ? (
                                <div className="d-flex justify-content-center">
                                    <div className='profile-box'>
                                        {this.state.personLoading ? (
                                            <div className="text-muted py-4">در حال بارگذاری اطلاعات اقامتگر...</div>
                                        ) : (
                                            <>
                                        <img className="profile-img"
                                             src="https://cdn-icons-png.flaticon.com/512/149/149071.png" alt="profile"/>
                                        <div
                                            className="name">{this.state.tempPerson.firstName || '—'} {this.state.tempPerson.lastName || ''}</div>
                                        <div className='profile-item'><AiOutlineNumber className='ms-2'/>کد
                                            ملی: {this.state.tempPerson.nationalCode || '—'}</div>
                                        <div className='profile-item'><MdDateRange className='ms-2'/>شروع
                                            اقامت: {this.state.tempPerson.timePeriod?.startDate || '—'}</div>
                                        <div className='profile-item'><AiOutlineUser
                                            className='ms-2'/>تاريخ تولد: {this.state.tempPerson.birthDate || '—'}</div>
                                        <div><button className="mt-3 btn btn-danger" onClick={()=>{this.handleDeletePerson()}}>اتمام اقامت</button></div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                <div className="search-container-popup">
                                    <div className="d-flex justify-content-center w-100">
                                        <div className="search-box">
                                            <div className="form-floating">
                                                <select className="form-select" id="floatingSelect"
                                                        aria-label="Floating label select example"
                                                        value={this.state.searchType} onChange={(e) => {
                                                    this.setState({searchType: e.target.value})
                                                }}>
                                                    <option value="fullName">نام و نام خانوادگی</option>
                                                    <option value="nationalCode">کد ملی</option>
                                                </select>
                                                <label htmlFor="floatingSelect">نوع</label>
                                            </div>
                                            <input type="text"
                                                   id="inputSearch"
                                                   placeholder="جسـتجـو..."
                                                   value={this.state.searchInput}
                                                   autoComplete="off"
                                                   onChange={(e) => {
                                                       this.handleSearchInput(e)
                                                   }}/>
                                            <div className="search-icon"><i className="bi bi-search"></i></div>
                                        </div>
                                    </div>
                                    <div className="people-container mt-4">
                                        <div className="people-found-scroll" style={{maxHeight: "220px", overflowY: "auto", width: "100%"}}>
                                            <ToggleButtonGroup
                                                orientation="vertical"
                                                value={this.state.selectedPeople}
                                                exclusive
                                                color="success"
                                                onChange={this.handleChange}
                                                aria-label="text alignment"
                                                style={{width: "100%"}}>
                                                {this.state.peopleFound.map((poeple) => (
                                                <ToggleButton key={poeple.parentId || poeple.id || poeple.nationalCode} value={poeple.parentId} style={{display: "block"}}>
                                                    <div className="row">
                                                        <div
                                                            className="col-3 profile-img d-flex align-items-center justify-content-center">
                                                            <BsPersonCircle fontSize="60px"/>
                                                        </div>
                                                        <div className="col-9 people-info row">
                                                            <div className="col-6">
                                                                <div className="d-flex">
                                                                    <label>نام و نام خانوادگی: </label>
                                                                    <p>{poeple.firstName} {poeple.lastName}</p>
                                                                </div>
                                                                <div className="d-flex">
                                                                    <label>نام پدر: </label>
                                                                    <p>{poeple.fatherName}</p>
                                                                </div>
                                                            </div>
                                                            <div className="col-6">
                                                                <div className="d-flex">
                                                                    <label>کد ملی :</label>
                                                                    <p>{poeple.nationalCode}</p>
                                                                </div>
                                                                <div className="d-flex">
                                                                    <label>تاریخ پذیرش :</label>
                                                                    <p>{poeple.timePeriod?.startDate || '—'}</p>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ToggleButton>
                                                ))}
                                            </ToggleButtonGroup>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </Modal.Body>
                    {
                        (this.state.bedOpen.empty || !this.state.bedOpen.person) ? (<Modal.Footer className="justify-content-start">
                            <button className="btn btn-success" onClick={() => {
                                this.handleSubmit()
                            }}>ثبت
                            </button>
                            <button className="btn btn-light" onClick={() => {
                                this.handleClose()
                            }}>بستن
                            </button>
                        </Modal.Footer>) : (
                            <Modal.Footer className="justify-content-start">
                                <button className="btn btn-light" onClick={() => this.handleClose()}>بستن</button>
                            </Modal.Footer>
                        )
                    }
                </Modal>
            </>
        );
    }

}

export default Bed;